// Beträge kommen aus der API in Cent
export const formatEuro = (cents: number): string =>
  new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);

// Prozentwert relativ zum Maximum, für Balkenbreiten/-höhen
export const percentOf = (value: number, max: number): string =>
  max > 0 ? `${Math.round((value / max) * 100)}%` : '0%';

// Lesbare Schriftfarbe (dunkel/hell) auf einer Mitgliedsfarbe
export const readableTextOn = (hex: string): string => {
  const h = hex.replace('#', '');
  if (h.length !== 6) return '#FFFFFF';
  const channel = (i: number) => {
    const c = parseInt(h.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  const luminance = 0.2126 * channel(0) + 0.7152 * channel(2) + 0.0722 * channel(4);
  return luminance > 0.3 ? '#0B1220' : '#FFFFFF';
};

// Kategorie-Farben, unterscheidbar auch in der Helligkeit
export const CATEGORY_COLORS = ['#FBBF24', '#60A5FA', '#F472B6', '#34D399', '#A78BFA', '#FB923C', '#94A3B8', '#22D3EE'];

// Feste Farbe je Kategorie für eine Saison: nach Gesamtbetrag absteigend vergeben,
// damit dieselbe Kategorie überall (Gesamt-Balken, Mitglieds-Details) gleich aussieht
export const categoryColorMap = (categories: { type: string; value: number }[]): Record<string, string> =>
  Object.fromEntries(
    [...categories]
      .sort((a, b) => b.value - a.value)
      .map((c, i) => [c.type, CATEGORY_COLORS[i % CATEGORY_COLORS.length] ?? '#94A3B8']),
  );
